import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as docketActions from '../../../redux/actions/docketActions';
import * as historyActions from '../../../redux/actions/historyActions';
import AllPartsPrintPreview from '../docket/popups/AllPartsPrintPreview';
import EmailCombinedPdfPopup from '../docket/popups/EmailCombinedPdfPopup';
import DownloadZipAllPdfsRangePopup from '../docket/popups/DownloadZipAllPdfsRangePopup';
import DownloadCombineAllPdfInRangePopup from '../docket/popups/DownloadCombineAllPdfInRangePopup';
import DownloadZipWithSubpartsPopup from '../docket/popups/DownloadZipWithSubpartsPopup';
import PrintAllPdfInRangePopup from '../docket/popups/PrintAllPdfInRangePopup';
import EmailPartPopup from '../docket/popups/EmailPartPopup';
import EmailPartModal from '../docket/popups/EmailPartModal/EmailPartModal';
import EmailAllPartsZipPopup from '../docket/popups/EmailAllPartsZipPopup';
import History from './History';

const section_type = 'history';
const parser_type = 'history_parser';
const noDataFoundMessage = 'No Transactions found.';
const loggedUser = window.Drupal.settings.currentUser;
const initState = {
  docNumFrom: null,
  docNumTo: null,
  startDate: null,
  endDate: null,
  pacerSearch: {
    startDate: null,
    endDate: null,
    doc_from: null,
    doc_to: null,
  },
  doc_range: '',
  doc_range_error: '',
  keyword: '',
  sort_field: 'date_filed',
  sort_direction: 'desc',
  ir_search_page_size: window.Drupal.settings.ir_search_page_size || 50,
};
export class HistoryContainer extends Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      ...initState,
      visibleDocketRow: '',
      selectedPageNum: 1,
      selectedDocketDetailNum: null,
      showEmailPopup: false,
      showEmailNotification: false,
      showPubliclinkPopup: false,
      showPacerFilterSection: this.props.purchase_right_away,
    };
    this.setDocketRowVisible = this.setDocketRowVisible.bind(this);
    this.togglePacerFilterSection = this.togglePacerFilterSection.bind(this);
    this.changePage = this.changePage.bind(this);
    this.getDocketDetails = this.getDocketDetails.bind(this);
  }
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

  onPopupClick = (params) => {
    this.props.dispatch(docketActions.togglePopup(params));
  }

  onClear = (e) => {
    this.setState(initState, () => {
      this.buyFilteredDockets(e);
    });
  }

  setDocketRowVisible = key => this.setState({ visibleDocketRow: key });

  getData = (page_num = 0, sort_direction = this.state.sort_direction, sort_field = this.state.sort_field) => {
    this.props.dispatch(historyActions.getParserSearchData({
      type: parser_type,
      case_uuid: this.props.case_uuid,
      date_from: '_',
      date_to: '_',
      doc_from: '_',
      doc_to: '_',
      keyword: '_',
      sort_field,
      sort_direction,
      page_num,
    }, null));
  }

  getParserData = (values) => {
    const date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '_';
    const date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '_';
    const doc_from = values.doc_from ? values.doc_from : '_';
    const doc_to = values.doc_to ? values.doc_to : '_';

    this.props.dispatch(historyActions.getParserSearchData({
      type: parser_type,
      case_uuid: this.props.case_uuid,
      date_from,
      date_to,
      doc_from,
      doc_to,
    }, null));
  }

  getPacerData = (values) => {
    const keyword = values.keyword ? values.keyword : '';
    const date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '';
    const date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '';
    const doc_from = values.doc_from ? values.doc_from : '';
    const doc_to = values.doc_to ? values.doc_to : '';
    const show_pending = values.pending ? values.pending : false;
    const show_terminated = values.terminated ? 1 : false;
    const doc_type = values.doc_type ? values.doc_type : '';
    this.props.dispatch(historyActions.getPacerRelatedData({
      type: section_type,
      case_uuid: this.props.case_uuid,
      keyword,
      date_from,
      date_to,
      doc_from,
      doc_to,
      show_pending,
      show_terminated,
      doc_type,
    }));
    this.getData();
  }

  getDocketDetails = (docket) => {
    this.setState({ selectedDocketDetailNum: docket.docket_seq }, () => {
      const params = {
        case_number: this.props.case_number,
        court_code: this.props.court_code,
        docket_no: docket.docket_no,
        docket_seq: docket.docket_seq,
      };
      this.props.dispatch(docketActions.getDocuments(params));
    });
  }

  purchaseData = (values) => {
    const history_type = values.history_type ? values.history_type : '';
    const show_docket = values.show_docket ? '1' : '0';
    this.props.dispatch(historyActions.purchaseHistoryCaseData({
      type: section_type,
      case_uuid: this.props.case_uuid,
      history_type,
      show_docket,
    }));
  }

  toggleEmailPopup() {
    this.setState({
      showEmailPopup: !this.state.showEmailPopup,
    });
  }

  closeEmailNotification() {
    this.setState({
      showEmailNotification: false,
    });
  }

  togglePublicLinkPopup() {
    this.setState({
      showPubliclinkPopup: !this.state.showPubliclinkPopup,
    });
  }
  togglePacerFilterSection() {
    this.setState({
      showPacerFilterSection: !this.state.showPacerFilterSection,
    });
  }
  changePage = (itemParams) => {
    this.setState({ selectedPageNum: itemParams.page_index });
    this.getData(itemParams.page_index);
  }

  getFilteredHistory = (page_num = 0, sort_direction = this.state.sort_direction, sort_field = this.state.sort_field) => {

    const params = {
      type: parser_type,
      case_uuid: this.props.case_uuid,
      date_from: '_',
      date_to: '_',
      doc_from: '_',
      doc_to: '_',
      keyword: '_',
      sort_field,
      sort_direction,
      page_num,
    };
    return this.props.dispatch(historyActions.getHistoryItems(params, null));
  }

  reloadDetails = (seqNum) => {
    this.getFilteredHistory()
      .then(() => this.getDocketDetails(seqNum));
  }

  sortHistory = (sort_field) => {
    const sort_direction = (this.state.sort_direction === 'asc')
      ? 'desc'
      : 'asc';

    this.setState({ sort_field, sort_direction });
    this.getData(0, sort_direction, sort_field);
  }

  changeFilter = (e, name) => {
    if (name === 'doc_range' && (!name.includes(',') || !name.includes('-'))) {
      this.setState({ [name]: e.target.value, doc_range_error: 'Please enter range in valid format!'});
    } else {
      this.setState({ [name]: e.target.value }, () => {
        this.props.dispatch(historyActions.filterHistoryEntries({ [name]: e.target.value }));
      });
    }
  }
  changeDate = (type, date) => {
    this.setState({ [type]: date });
  }
  handleDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = (next.length < 2)
        ? `0${next}`
        : next;

      return (idx === 0)
        ? accum + n
        : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    this.setState({ [type]: d });
  }

  handleDocRange = (range) => {
    const ranges = { doc_from: '_', doc_to: '_', mid_range: '_', delimeter: '_' };
    // check if its not empty
    if (range) {
      if (range.includes(',') && range.includes('-')) {
        // special check for number - number, number
        range = range.replace(/\s+/g, '');
        const [doc_from, doc_to] = range.split('-');
        ranges.doc_from = doc_from || '_';
        const [mid_range, end_range] = doc_to.split(',');
        ranges.doc_to = end_range || '_';
        ranges.mid_range = mid_range;
        ranges.delimeter = '*';
      } else if (range.includes(',')) {
        range = range.replace(/\s+/g, '');
        const [doc_from, doc_to] = range.split(',');
        ranges.doc_from = doc_from || '_';
        ranges.doc_to = doc_to || '_';
        ranges.delimeter = ',';
      } else if (range.includes('-')) {
        range = range.replace(/\s+/g, '');
        const [doc_from, doc_to] = range.split('-');
        ranges.doc_from = doc_from || '_';
        ranges.doc_to = doc_to || '_';
        ranges.delimeter = '-';
      } else {
        ranges.doc_from = range;
      }
    }
    return ranges;
  }
  buyFilteredDockets = (e) => {
    e.preventDefault();
    this.setState({ showLoadingBar: true });
    const { startDate, endDate, doc_range, keyword } = this.state;
    const doc_range_object = this.handleDocRange(doc_range);
    const params = {
      type: parser_type,
      case_uuid: this.props.case_uuid,
      // is_ajax: 1,
      // receipt_only: 1,
      query: 'history_search',
      date_from: startDate ? startDate.format('MM-DD-YYYY') : '_',
      date_to: endDate ? endDate.format('MM-DD-YYYY') : '_',
      doc_from: doc_range_object.doc_from,
      doc_to: doc_range_object.doc_to,
      delimeter: doc_range_object.delimeter,
      keyword: _.isEmpty(keyword) ? '_' : keyword,
      sort_field: this.state.sort_field,
      sort_direction: this.state.sort_direction,
      page_num: 0,
    };
    this.props.dispatch(historyActions.getParserSearchData(params, null));
  }

  popupForm = {
    EmailCombinedPdfPopup,
    AllPartsPrintPreview,
    DownloadZipAllPdfsRangePopup,
    DownloadZipWithSubpartsPopup,
    DownloadCombineAllPdfInRangePopup,
    PrintAllPdfInRangePopup,
    EmailPartPopup,
    EmailPartModal,
    EmailAllPartsZipPopup,
  }

  render() {
    const { entries = {} } = this.props.history;
    const { name } = this.props.popup;
    const HistoryPopup = this.props.popup.show && this.popupForm[name];
    
    const docketFilterProps = {
      keyword: this.state.keyword,
      doc_range: this.state.doc_range,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      onChange: this.changeFilter,
      changeDate: this.changeDate,
      onChangeDateRaw: this.handleDateChangeRaw,
      buyFilteredDockets: (e) => this.setState({ showLoadingBar: true }, this.buyFilteredDockets(e)),
      onClear: this.onClear,
    };
    const historyPaginatorProps = {
      history: this.props.history,
      case_uuid: this.props.case_uuid,
      court_code: this.props.court_code,
      case_number: this.props.case_number,
      selectedPageNum: this.state.selectedPageNum,
      changePage: this.changePage,
      dispatch: this.props.dispatch,
    };
    const historyEntriesProps = {
      entries,
      history: this.props.history,
      redactSeqNum: this.state.redactSeqNum,
      buyMissingDockets: this.buyMissingDockets,
      getDocketDetails: this.getDocketDetails,
      showRedactPopup: this.showRedactPopup,
      case_uuid: this.props.case_uuid,
      court_code: this.props.court_code,
      case_number: this.props.case_number,
      sortHistory: this.sortHistory,
      selectedDocketDetailNum: this.state.selectedDocketDetailNum,
      keyword: this.state.keyword,
      selectedDocket: this.props.selectedDocket,
    };
    const tableSortProps = {
      sort_direction: this.state.sort_direction,
      sort_field: this.state.sort_field,
    };

    return (
      <History
        {...this.props}
        type={section_type}
        purchaseData={this.purchaseData}
        onSubmit={value => this.purchaseData(value)}
        showPacerFilterSection={this.state.showPacerFilterSection}
        togglePacerFilterSection={this.togglePacerFilterSection}
        togglePublicLinkPopup={this.togglePublicLinkPopup}
        noDataFoundMessage={noDataFoundMessage}
        historyPaginatorProps={historyPaginatorProps}
        docketParts={this.props.docketParts}
        getDocketDetails={this.getDocketDetails}
        docketFilterProps={docketFilterProps}
        historyEntriesProps={historyEntriesProps}
        tableSortProps={tableSortProps}
        HistoryPopup={HistoryPopup}
        onPopupClick={this.onPopupClick}
      />
    );
  }
}

HistoryContainer.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

HistoryContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  docketParts: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const historyReducer = state.get('history').toJS();
  const irSearch = state.get('irSearch').toJS();

  historyReducer.data = [...historyReducer.data, ...irSearch.data];
  const history = historyReducer.data.reduce((accum, next) => {
    // eslint-disable-next-line
    accum[next[0]] = next[1];
    return accum;
  }, {});

  const { popup, docketParts, selectedDocket } = state.get('dockets').toJS();

  return {
    dataReady: historyReducer.data_ready,
    // dockets,
    history,
    popup,
    docketParts,
    receipt: historyReducer.receipt,
    lastUpdated: historyReducer.lastUpdated,
    error: historyReducer.error,
    selectedDocket,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});


export default connect(mapStateToProps, mapDispatchToProps)(HistoryContainer);



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryContainer.js